import { apiClient } from "../axiosClient";

export interface Country {
  id: number;
  country_name: string;
  country_code: string;
  is_active: boolean;
}

export const getCountries = async (): Promise<Country[]> => {
  const response = await apiClient.get("/master/countries", {
    params: {
      isActive: true,
    },
  });

  return response.data.data;
};
